import { getI18n } from 'react-i18next';

export const VALIDATION_EMAIL_TEMPLATE_EMPTY_NAME = 'validation.emailTemplate.emptyName';
export const VALIDATION_EMAIL_TEMPLATE_INVALID_NAME_LENGTH = 'validation.emailTemplate.invalidNameLength';
export const VALIDATION_EMAIL_TEMPLATE_EMPTY_RECIPIENTS = 'validation.emailTemplate.emptyRecipients';
export const VALIDATION_EMAIL_TEMPLATE_INVALID_RECIPIENTS_LENGTH = 'validation.emailTemplate.invalidRecipientsLength';
export const VALIDATION_EMAIL_TEMPLATE_INVALID_RECIPIENTS = 'validation.emailTemplate.invalidRecipients';
export const VALIDATION_EMAIL_TEMPLATE_EMPTY_SUBJECT = 'validation.emailTemplate.emptySubject';
export const VALIDATION_EMAIL_TEMPLATE_INVALID_SUBJECT_LENGTH = 'validation.emailTemplate.invalidSubjectLength';
export const VALIDATION_EMAIL_TEMPLATE_EMPTY_BODY = 'validation.emailTemplate.emptyBody';
export const VALIDATION_EMAIL_TEMPLATE_INVALID_BODY_LENGTH = 'validation.emailTemplate.invalidBodyLength';
export const VALIDATION_EMAIL_TEMPLATE_EMPTY_PRODUCT_ID = 'validation.emailTemplate.emptyProductId';
export const ERROR_EMAIL_TEMPLATE_NOT_FOUND = 'emailTemplate.notFound';

export const createEmailTemplateErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case VALIDATION_EMAIL_TEMPLATE_EMPTY_NAME:
            result = i18n.t('email-templates.error.email-template-name-empty');
            break;
        case VALIDATION_EMAIL_TEMPLATE_INVALID_NAME_LENGTH:
            result = i18n.t('email-templates.error.email-template-name-invalid-length', params);
            break;
        case VALIDATION_EMAIL_TEMPLATE_EMPTY_RECIPIENTS:
            result = i18n.t('email-templates.error.email-template-recipients-empty');
            break;
        case VALIDATION_EMAIL_TEMPLATE_INVALID_RECIPIENTS_LENGTH:
            result = i18n.t('email-templates.error.email-template-recipients-invalid-length', params);
            break;
        case VALIDATION_EMAIL_TEMPLATE_INVALID_RECIPIENTS:
            result = i18n.t('email-templates.error.email-template-recipients-invalid');
            break;
        case VALIDATION_EMAIL_TEMPLATE_EMPTY_SUBJECT:
            result = i18n.t('email-templates.error.email-template-subject-empty');
            break;
        case VALIDATION_EMAIL_TEMPLATE_INVALID_SUBJECT_LENGTH:
            result = i18n.t('email-templates.error.email-template-subject-invalid-length', params);
            break;
        case VALIDATION_EMAIL_TEMPLATE_EMPTY_BODY:
            result = i18n.t('email-templates.error.email-template-body-empty');
            break;
        case VALIDATION_EMAIL_TEMPLATE_INVALID_BODY_LENGTH:
            result = i18n.t('email-templates.error.email-template-body-invalid-length', params);
            break;
        case VALIDATION_EMAIL_TEMPLATE_EMPTY_PRODUCT_ID:
            result = i18n.t('email-templates.error.email-template-product-id-empty');
            break;
        case ERROR_EMAIL_TEMPLATE_NOT_FOUND:
            result = i18n.t('email-templates.error.email-template-not-found');
            break;
        default:
            result = undefined;
    }
    return result;
};
